import { ConfigProvider, Spin } from 'antd';
import antAR from 'antd/locale/ar_EG';
import antEN from 'antd/locale/en_US';
import 'bootstrap/dist/css/bootstrap.min.css';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import i18n from 'i18next';
import { useEffect } from 'react';
import { useRoutes } from 'react-router-dom';
import OfflineIndicator from './components/OfflineIndicator';
import { AuthProvider } from './contexts/AuthContext';
import { useInternetConnection, useOfflineMutations } from './hooks/useConnection';
import useUserRedirectHandler from './hooks/useUserRedirectHandler';
import routes from './routes';
import { initDeviceId } from './utils/getDeviceId';

dayjs.extend(utc);
dayjs.extend(timezone);

// Wrapper component that only renders routes after authentication
const AppRoutes = () => {
  const element = useRoutes(routes);
  return element;
};

function App() {
  const { isProcessingToken } = useUserRedirectHandler();
  const isArabic = i18n.language === 'ar';

  useEffect(() => {
    initDeviceId();
  }, []);

  // Only run these hooks after token processing is complete
  const isOnline = useInternetConnection();
  useOfflineMutations();

  // Show loading while processing token
  if (isProcessingToken) {
    return (
      <ConfigProvider locale={isArabic ? antAR : antEN} direction={isArabic ? 'rtl' : 'ltr'}>
        <AuthProvider value={{ isAuthenticated: false }}>
          <div className="flex items-center justify-center min-h-screen bg-gray-50">
            <Spin size="large" />
          </div>
        </AuthProvider>
      </ConfigProvider>
    );
  }

  return (
    <ConfigProvider locale={isArabic ? antAR : antEN} direction={isArabic ? 'rtl' : 'ltr'}>
      <AuthProvider value={{ isAuthenticated: true }}>
        <OfflineIndicator isOnline={isOnline} />
        <AppRoutes />
        {/* {!allow && <PinChecker pin={pin} onPass={() => setAllow(true)} />} */}
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
